import BvFlashContainer from '../../components/bv-flash-container';
import BasicDropdownWormhole from 'ember-basic-dropdown/components/basic-dropdown-wormhole';
import pageTitle from 'ember-page-title/helpers/page-title';
import RouteTemplate from 'ember-route-template';

export default RouteTemplate<{ Args: { model: unknown; controller: unknown } }>(
  <template>
    {{! template-lint-disable no-bare-strings }}
    {{pageTitle 'VOLTA'}}
    {{outlet}}

    <BvFlashContainer @position='bottom-right' />
    <BasicDropdownWormhole />
  </template>
);
